import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSelected = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 11,
		cy: 11,
		r: 11,
		fill: "#8100FE"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7 11.1351L9.73965 14L15 8",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "square"
	})]
});
export default SvgSelected;
